const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- calendar-habits ---
let __fez_component_0;
{

__fez_component_0 = class {
  PROPS = {
    habits: { type: Array, default: [] },
    day: String,
    compact: Boolean,
    on_check: { type: Function, state: true, default: () => {} },
  }

  check(ref) {
    const chip = this.props.habits.find((entry) => entry.ref === ref)
    if (chip && !chip.later) this.state.on_check(ref, this.props.day, !chip.done)
  }

  CSS = `:fez {
display:block;.hb{display:flex;flex-wrap:wrap;gap:var(--space-1)}.hb-chip{display:inline-flex;align-items:center;gap:var(--space-1);min-width:0;height:26px;padding:0 var(--space-2) 0 6px;border:1px solid color-mix(in srgb,var(--tag) 45%,var(--color-border));border-radius:var(--radius-full);background:var(--color-bg-raised);color:var(--color-text-muted);font:inherit;font-size:var(--text-xs);font-weight:var(--weight-medium);cursor:pointer;&:hover{border-color:var(--tag);color:var(--color-text)}&:focus-visible{outline:2px solid var(--color-focus);outline-offset:1px}&.done{border-color:var(--tag);background:var(--tag);color:var(--color-text-inverse)}&:disabled{opacity:0.45;cursor:default}}.hb-mark{display:inline-flex;flex:none;color:var(--tag)}.hb-chip.done .hb-mark{color:inherit}.hb-name{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.hb.compact{gap:3px;justify-content:center;.hb-chip{justify-content:center;width:22px;height:22px;padding:0}}
}`

  HTML = `<div class="hb" class:compact={props.compact}>
{#each props.habits as chip}
<button type="button" class="hb-chip" class:done={chip.done} key={chip.ref} style="--tag: var(--color-avatar-{chip.color})" disabled={chip.later} aria-pressed={chip.done ? 'true' : 'false'} title={chip.title} aria-label={chip.title} onclick="fez.check('{chip.ref}')">
<span class="hb-mark"><ui-icon name={chip.icon} size={props.compact ? '13' : '14'}></ui-icon></span>
{#if !props.compact}<span class="hb-name">{chip.name}</span>{/if}
</button>
{/each}
</div>`
};
}

Fez('calendar-habits', __fez_component_0);

export default __fez_component_0;
